class Carousel {
  constructor(id, config) {
    this.el = document.getElementById(id);
    this.config = config;
    this.carousel = null;
    this.init();
  }

  init() {
    if (this.el) {
      this.carousel = new Splide(this.el, this.config);
      this.carousel.mount();
    }
  }
}

window.addEventListener("load", () => {
  new Carousel("jsCarouselBanner", {
    autoWidth: false,
    perMove: 1,
    perPage: 1,
    autoplay: true,
    type: "fade",
    gap: "30px",
    rewind: true,
    speed: 1000,
    pagination: true,
    arrows: false,
  });

  new Carousel("jsCarouselAbout", {
    autoWidth: false,
    perMove: 1,
    perPage: 1,
    autoplay: true,
    type: "fade",
    gap: "30px",
    rewind: true,
    speed: 1000,
    pagination: true,
    arrows: false,
  });


  let carouselCardEls = document.querySelectorAll(".jsCarouselCard");
  if(carouselCardEls.length > 0) {
    carouselCardEls.forEach(carouselCardEl => {
      new Carousel(carouselCardEl.id, {
        autoWidth: true,
        autoplay: false,
        gap: "5px",
        speed: 1000,
        pagination: false,
        arrows: true,
        breakpoints: {
          992: {
            pagination: true,
            arrows: false,
          },
        },
      });      
    });
  }

  new Carousel("jsCarouselFeedback", {
    autoWidth: true,
    autoplay: false,
    gap: "50px",
    focus: "center",
    type: "loop",
    speed: 1000,
    pagination: true,
    arrows: false,
  });
});
